export default __webpack_public_path__ + "static/media/demo_guide.65a78739.mp4";